import { render, staticRenderFns } from "./IconHeart.vue?vue&type=template&id=900629b0&scoped=true&"
import script from "./IconHeart.vue?vue&type=script&lang=js&"
export * from "./IconHeart.vue?vue&type=script&lang=js&"
import style0 from "./IconHeart.vue?vue&type=style&index=0&id=900629b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900629b0",
  null
  
)

export default component.exports